import { render } from "./purchases-details.vue?vue&type=template&id=cf97c72a"
import script from "./purchases-details.vue?vue&type=script&lang=js"
export * from "./purchases-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__